export function apiErrorMessage(error, fallback) {
    const payload = error?.response?.data?.error;
    if (typeof payload === "string" && payload.trim()) return payload;
    if (payload?.message) return payload.message;
    if (error?.message) return error.message;
    return fallback;
}

export function signingLinksFromResponse(data) {
    return Array.isArray(data?.signers)
        ? data.signers.filter((signer) => signer?.uuid || signer?.id)
        : [];
}

export async function copySigningLink(value, clipboard, documentRef) {
    const text = String(value || "");
    if (!text) throw new Error("A signing link is not available.");
    const browserClipboard = clipboard === undefined && typeof navigator !== "undefined" ? navigator.clipboard : clipboard;
    const browserDocument = documentRef === undefined && typeof document !== "undefined" ? document : documentRef;
    if (browserClipboard?.writeText) {
        try {
            await browserClipboard.writeText(text);
            return true;
        } catch (_error) {
            // Permissions and secure-context rules vary; use the selection fallback.
        }
    }
    if (!browserDocument?.body || typeof browserDocument.execCommand !== "function") {
        throw new Error("Copy is not supported in this browser.");
    }

    const input = browserDocument.createElement("textarea");
    input.value = text;
    input.setAttribute("readonly", "");
    input.style.position = "fixed";
    input.style.opacity = "0";
    browserDocument.body.appendChild(input);
    input.select();
    const copied = browserDocument.execCommand("copy");
    browserDocument.body.removeChild(input);
    if (!copied) throw new Error("Copy is not supported in this browser.");
    return true;
}
